import React from 'react';

function Notfound() {
  return <h1 className="text-9xl text-center">Notfound</h1>;
}

export default Notfound;
